import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import { Footer } from '../../Components/Footer/Footer'
import GREs from '../../Components/GRE/GRE'

const GRE = () => {
    return (
        <>
            <Navbar />
            <GREs />
            <Footer />
        </>
    )
}

export default GRE